import applicationGraphs from '@/utils/templates/browserTemplate/application.graphs.config';
import pagesGraphs from '@/utils/templates/browserTemplate/page.graphs.config';
const browser = {
  application: [
    applicationGraphs().lineCharts,
    applicationGraphs().barCharts,
    applicationGraphs().heatMaps,
  ],
  pages: [
    pagesGraphs().lineCharts,
    pagesGraphs().areaCharts,
    pagesGraphs().barCharts,
    pagesGraphs().heatMap,
  ],
};
export default browser;
